import type { FaireProductEntity } from "../../entity_types/product";

export const p_mut8qx6x33: FaireProductEntity = {
  token: "p_mut8qx6x33",
  type: "product",
  name: "Celestial Constellations: 12 Notecards and Envelopes",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/33235700286825e7824daf4064e396624e635d4d78904ca78b74de91947ea18b.jpeg",
  galleryImageUrls: [],
  priceDollars: 10,
  description: "This notecard set features 12 beautifully illustrated cards and matching envelopes, showcasing archival artwork from the American Museum of Natural History’s rare book collection. Each card features a detail from two extraordinary nineteenth-century sky atlases, with astronomical constellations from the zodiac—one for every sign.",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:07:00.800Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
